import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "./context/AuthProvider";

function Logout() {
  const { setAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const logout = async () => {
      // if used in more components, this should be in context
      // axios to /logout endpoint
      setAuth({});
      navigate("/");
    };

    logout();
  }, [setAuth, navigate]);

  return null; // Or you can return a loading indicator or a message
}

export default Logout;
